
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ContactCTA from '@/components/ContactCTA';
import BrokerageHero from '@/components/brokerage/BrokerageHero';
import BrokerageComparison from '@/components/brokerage/BrokerageComparison';
import BrokerageFeatures from '@/components/brokerage/BrokerageFeatures';
import BrokerageUseCases from '@/components/brokerage/BrokerageUseCases';
import BrokerageCostSavings from '@/components/brokerage/BrokerageCostSavings';
import BrokeragePhilosophy from '@/components/brokerage/BrokeragePhilosophy';
import BrokerageFinalCTA from '@/components/brokerage/BrokerageFinalCTA';

const Brokerage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BrokerageHero />
      <BrokerageComparison />
      <BrokerageFeatures />
      <BrokerageUseCases />
      <BrokerageCostSavings />
      <BrokeragePhilosophy />
      <BrokerageFinalCTA />
      <ContactCTA />
      <Footer />
    </div>
  );
};

export default Brokerage;
